import React,{Component} from 'react';
import PropTypes from 'prop-types';
import Joyride from 'react-joyride';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import Button from '../../../shared/components/Button';

class AgencyIntroduction extends Component {
  constructor(){
    super();

    this.state = {
      closed:false,
      hasStartedJoyRide:false,
      isShowingIntroModal:false
    };
  }

  componentWillMount(){
    if(this.props.show){
      this.setState({isShowingIntroModal:true});
    }
  }

  handleJoyrideEvent(event){
    if(event.action === 'close' && !this.state.closed){
      this.setState({isShowingIntroModal:false,closed:true});
      this.props.onCompletion();
    } else if(event.action === 'skip' && event.type === 'finished'){
      this.props.onCompletion();
    } else if(event.action === 'start' && event.type === 'step:before'){
      this.props.onStart(event);
    } else if(event.action === 'next' && event.type === 'step:before'){
      this.props.onStep(event);
    } else if(event.action === 'next' && event.type === 'finished'){
      this.props.onCompletion();
      this.setState({isShowingIntroModal:false});
    }
  }

  handleStartClicked(){
    this.props.onStart();
    this.setState({hasStartedJoyRide:true});
  }

  handleSkipClicked(){
    this.setState({isShowingIntroModal:false});
    this.props.onCompletion();
  }

  render(){
    return (
      <div>
        <Modal isOpen={this.props.show && this.state.isShowingIntroModal && !this.state.hasStartedJoyRide}>
          <ModalHeader>Welcome to the Dabbl Ad Manager</ModalHeader>
          <ModalBody>
            <p>
              Let’s go through a quick overview to get you started.
            </p>
            <p>
              Feel free to skip the walkthrough at any time if you'd prefer to explore the Ad Manager on your own.
            </p>
            <p>
              Ready to start connecting with consumers?
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => this.handleStartClicked()}
            >
              Let's Go!
            </Button>
            <Button
              textColor='black'
              backgroundColor='transparent'
              onClick={() => this.handleSkipClicked()}
            >
              Skip Overview
            </Button>
          </ModalFooter>
        </Modal>
        <Joyride
          autoStart
          ref={(j) => this.joyride = j}
          run={this.state.hasStartedJoyRide && !this.state.closed}
          showBackButton={false}
          showSkipButton={true}
          scrollOffset={20}
          callback={(e) => this.handleJoyrideEvent(e)}
          type='continuous'
          locale={{
            skip:'Skip',
            back:'Back',
            next:'Next',
            last:'Let\'s Go!'
          }}
          steps={[
            {
              title:'1 of 6',
              text:'After your first experience begins, view real time metrics to see how consumers are engaging with your brand.',
              selector:'.CampaignStats',
              position:'bottom',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'2 of 6',
              text:'When a consumer completes an experience, we ask how much fun she had.  The average of all these responses becomes your "Rating".',
              selector:'.AdjoyabilityDial',
              position:'bottom',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'3 of 6',
              text:'Manage your existing experiences and view their statuses.',
              selector:'.DashboardCampaignList',
              position:'top',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'4 of 6',
              text:'Want to view metrics for a particular brand or brands?  Select one or more to filter.',
              selector:'.ActiveBrandsDropDownMenu',
              position:'right',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'5 of 6',
              text:'Edit your profile information, manage team profiles, and create new brand profiles here.',
              selector:'.ProfileDropdownMenu',
              position:'bottom',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'6 of 6',
              text:'Click here to see real time consumer responses to your activities.',
              selector:'.CampaignResultsButton',
              position:'left',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            },
            {
              title:'Overview complete',
              text:'You are now a Dabbl admaster.  <br />Ready to build an experience?',
              selector:'.CreateCampaignButton',
              position:'left',
              style:{
                mainColor:'#e96224',
                beacon:'#e96224'
              }
            }
          ]}
        />
      </div>
    )
  }
}

AgencyIntroduction.propTypes = {
  show:PropTypes.bool,
  onStart:PropTypes.func,
  onStep:PropTypes.func,
  onCompletion:PropTypes.func
};

AgencyIntroduction.defaultProps = {
  show:false,
  onStart:() => {},
  onStep:() => {},
  onCompletion:() => {}
}

export default AgencyIntroduction;



// WEBPACK FOOTER //
// ./src/routes/AgencyPortal/components/AgencyIntroduction.js